module.exports = __webpack_public_path__ + "img/ico6.3e2774f3.png";